import { render } from "./ManageAccount.vue?vue&type=template&id=294a2c46"
import script from "./ManageAccount.vue?vue&type=script&lang=js"
export * from "./ManageAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__